import React, {Component} from 'react';
import './Range.css';

export default class Range extends React.Component {
    constructor(props) {
      super(props);
      this.updateRange = this.updateRange.bind(this);
      this.updateSelection = this.updateSelection.bind(this);
    }
    
    updateRange(e) {
      this.props.updateRange(e.target.value);
    }

    updateSelection(e) {
        this.props.updateSelection(this.props.range)
    }
    
    render() {
      // console.log(this.props);
      const { range } = this.props;
      return (
        <div className="range-group">
          <input className="range-group__range" type="range"
            value={range}
            min="0"
            max="1"
            step="0.01"
            onChange={this.updateRange}
          />
          <span className="range-group__output">{range}</span>
          <span onClick={this.updateSelection} className="range-group__update">Update</span>
        </div>
      )
    }
  }
  
  